import axios from 'utils/axios';

export const updateServicePackageAttachment = (data: any, isGroup?: boolean) => {
  const { id, ...rest } = data;
  return axios.put(
    isGroup ? `/api/v1/servicepackages/mfo/attachments/${id}` : `/api/v1/servicepackages/mfo/attachments/${id}`,
    rest
  );
};
